<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01L12 2z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconStarFilled',
  props: { size: { type: [String, Number], default: 24 } },
};
</script>
